var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2751 0.00012207C41.5596 0.00012207 44.222 2.66265 44.222 5.94703V37.6639C44.222 40.9484 41.5596 43.6108 38.2751 43.6108H6.55824C3.27386 43.6108 0.611328 40.9484 0.611328 37.6639V5.94703C0.611328 2.66265 3.27386 0.00012207 6.55824 0.00012207H38.2751ZM38.2751 3.96473C39.3699 3.96473 40.2574 4.85225 40.2574 5.94703V37.6639C40.2574 38.7587 39.3699 39.6462 38.2751 39.6462H28.3636V25.7699H32.4792C33.3324 25.7699 34.0899 25.2239 34.3598 24.4144L35.238 21.7799C35.5589 20.8171 34.8423 19.823 33.8276 19.823H28.3636V15.8584C28.3636 14.8672 29.3547 13.8761 30.3459 13.8761H34.3105C35.4053 13.8761 36.2928 12.9886 36.2928 11.8938V10.5339C36.2928 9.89362 35.8838 9.31952 35.2646 9.15612C32.6662 8.4704 30.3459 8.47041 30.3459 8.47041C25.3901 8.47041 22.4167 11.8938 22.4167 14.8672V19.823H18.4521C17.3573 19.823 16.4698 20.7104 16.4698 21.8053V23.7876C16.4698 24.8824 17.3573 25.7699 18.4521 25.7699H22.4167V39.6462H6.55824C5.46345 39.6462 4.57593 38.7587 4.57593 37.6639V5.94703C4.57593 4.85225 5.46345 3.96473 6.55824 3.96473H38.2751Z",
    fill: "#003049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.35f307f2067469ec2e00592b5850e6e4.svg";
export { ForwardRef as ReactComponent };